<script>
export default {
  props: {
    header: {
      type: Object,
      required: true
    },
    activeSort: {
      type: String,
      required: false,
      default: ''
    },
    activeFilters: {
      type: Array,
      required: false,
      default: () => {}
    }
  },
  computed: {
    sn_snTableFilterMixin_hasSort () {
      return this.header.sortBy?.some(sv => sv.value === this.activeSort)
    },
    sn_snTableFilterMixin_hasAscSort () {
      return this.activeSort?.toLowerCase()?.includes('asc') && this.sn_snTableFilterMixin_hasSort
    },
    sn_snTableFilterMixin_hasDescSort () {
      return this.sn_snTableFilterMixin_activeSort?.toLowerCase()?.includes('desc') && this.sn_snTableFilterMixin_hasSort
    },
    sn_snTableFilterMixin_hasSearch () {
      return !!this.header.searchable
    },
    sn_snTableFilterMixin_hasFilter () {
      return this.header.filterBy?.nodes?.some(fv => this.activeFilters.includes(fv.value))
    },
    sn_snTableFilterMixin_sortFilterIcon () {
      if (this.sn_snTableFilterMixin_hasFilter) {
        return '$snFilters2'
      } else if (this.sn_snTableFilterMixin_hasDescSort) {
        return '$snChevronUp'
      } else if (this.sn_snTableFilterMixin_hasAscSort) {
        return '$snChevronDown'
      } else {
        return null
      }
    }
  }
}
</script>
